module.exports = __webpack_public_path__ + "6f4bf5f68f54d2b9d2a2ee67aed9aeee.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/rating.png
// module id = ./assets/images/rating.png
// module chunks = 0